<!--modal start-->
<div class="modal-body p-0">
  <div class="x_content custom-tab">
    <ul class="nav bar_tabs nav-justify-content tab-res-space px-2 border-bottom" id="myTab" role="tablist">
      <li class="nav-item"><a class="nav-link ml-3" id="details-tab" (click)="onChangeTab('details')" [ngClass]="{ 'active':selTab1}"  data-toggle="tab" href="#details" role="tab" aria-controls="details" aria-selected="true">Details</a></li>

      <li class="nav-item" *ngIf="!show"><a class="nav-link disabled" data-toggle="tab" role="tab" aria-controls="attendees" aria-selected="false">Attendees</a></li>
      <li class="nav-item" *ngIf="!show"><a class="nav-link disabled" data-toggle="tab" role="tab" aria-controls="Workflow" aria-selected="false">Workflow</a></li>
      <li class="nav-item" *ngIf="!show"><a class="nav-link disabled" data-toggle="tab" role="tab" aria-controls="discussion" aria-selected="false">Meeting Discussions</a></li>
      <li class="nav-item" *ngIf="!show"><a class="nav-link disabled" data-toggle="tab" role="tab" aria-controls="actionspoints" aria-selected="false">Actions Points</a></li>
      <li class="nav-item" *ngIf="!show"><a class="nav-link disabled" data-toggle="tab" role="tab" aria-controls="files" aria-selected="false">Files</a></li>

      <li class="nav-item" *ngIf="show"><a class="nav-link" id="attendees-tab" (click)="onChangeTab('attendees')" [ngClass]="{ 'active':selTab2}" data-toggle="tab" href="#attendees" role="tab" aria-controls="attendees" aria-selected="false">Attendees</a></li>
      <li class="nav-item" *ngIf="show"><a class="nav-link" id="Workflow-tab" (click)="onChangeTab('Workflow')" [ngClass]="{ 'active':selTab3}" data-toggle="tab" href="#Workflow" role="tab" aria-controls="Workflow" aria-selected="false">Workflow</a></li>
      <li class="nav-item" *ngIf="show"><a class="nav-link" id="discussion-tab" (click)="onChangeTab('discussions')" [ngClass]="{ 'active':selTab6}" data-toggle="tab" href="#discussion" role="tab" aria-controls="discussion" aria-selected="false">Meeting Discussions</a></li>
      <li class="nav-item" *ngIf="show"><a class="nav-link" id="actionspoints-tab" (click)="onChangeTab('actionspoints')" [ngClass]="{ 'active':selTab4}" data-toggle="tab" href="#actionspoints" role="tab" aria-controls="actionspoints" aria-selected="false">Actions&nbsp;Points</a></li>

      <li class="nav-item" *ngIf="show"><a class="nav-link" id="files-tab" (click)="onChangeTab('files')" [ngClass]="{ 'active':selTab5}" data-toggle="tab" href="#files" role="tab" aria-controls="files" aria-selected="false">Files</a></li>
    </ul>

    <div class="tab-content px-4 editMeeting" id="myTabContent">
      <div class="tab-pane fade" [ngClass]="{ 'active show':selTab1}" id="details" role="tabpanel" aria-labelledby="details-tab">
        <div class="row">
          <div class="col-md-8">
            <form name="gf" id="gf" #gf="ngForm" novalidate>
              <div class="text-right py-0"
                  *ngIf="!show && loginUsrEmail?.toLowerCase().endsWith('@dewa.gov.ae')">
  
                      <a class="btn btn-outline-primary f-bold-dubai mt-3"
                        (click)="openImport(importtemplate)">
                        <img class="whx-30" src="\assets\v2\img\word-icon.png" />
                        Retrieve from Outlook
                      </a>

                    </div>

              <div class="form-group pt-1">
                <label for="Subject">Subject<span class="text-danger">*</span></label>
                <input type="email" class="form-control" aria-describedby="Subject" placeholder="Enter the subject for this meeting" id="subject" name="subject"
                       [ngClass]="{ 'error': isSubmit && subject.invalid }"
                       [(ngModel)]="model.subjectAtd" required #subject="ngModel">
                <div *ngIf="isSubmit && subject.invalid">
                  <div class="text-danger">Subject is required</div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="form-group" *ngIf="isMeetingEdit == true">
                    <label for="meetingData">Date<span class="text-danger">*</span></label>
                    <input type="date" onkeydown="return false" class="form-control" [(ngModel)]="model.fMeetingDateAtd" required
                           #meetingDate="ngModel" id="meetingDate" name="meetingDate" aria-describedby="date" [ngClass]="{ 'error': isSubmit && meetingDate.invalid }" min="2000-01-02" [max]="today" (keydown)="preventKeydownEndtime($event)" (change)="setCurrentTimeforendtime()">
                    <div *ngIf="isSubmit && meetingDate.invalid">
                      <div class="text-danger"> Date is required</div>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="isMeetingEdit == false">
                    <label for="meetingData">Date<span class="text-danger">*</span></label>
                    <input type="text" onfocus="(this.type='date')" placeholder="MM/DD/YYYY" onkeydown="return false" class="form-control" [(ngModel)]="model.fMeetingDateAtd" required
                           #meetingDate="ngModel" id="meetingDate" name="meetingDate" aria-describedby="date" [ngClass]="{ 'error': isSubmit && meetingDate.invalid }" min="2000-01-02" [max]="today" (keydown)="preventKeydownEndtime($event)" (change)="setCurrentTimeforendtime()">
                    <div *ngIf="isSubmit && meetingDate.invalid">
                      <div class="text-danger"> Date is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6">
                  <div class="form-group">
                    <label for="Subject">Location<span class="text-danger">*</span></label>
                    <ng-select [items]="locationdaList" class="form-control p-0"
                               bindLabel="locationName"
                               appendTo="body"
                               required #locationName="ngModel"
                               [(ngModel)]="model.locationUno"
                               id="locationName"
                               name="locationName"
                               [ngClass]="{ 'error': isSubmit && locationName.invalid }"
                               bindValue="locationUno"
                               [searchable]="true"
                               [virtualScroll]="true"
                               [minTermLength]="1"
                               [multiple]="false"
                               (change)="locationChange($event)"
                               placeholder="Location">
                    </ng-select>

                    <div *ngIf="isSubmit && locationName.invalid">
                      <div class="text-danger"> Location is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6" *ngIf="isOthers">
                  <div class="form-group">
                    <label for="Subject">Others</label>
                    <input type="text" class="form-control" aria-describedby="date" placeholder="Others" [(ngModel)]="model.others" id="others" name="others">
                  </div>
                </div>
                <div class="col-md-6 col-sm-6">
                  <div class="form-group">
                    <label for="Subject">Start Time<span class="text-danger">*</span></label>
                    <input type="time" class="form-control" aria-describedby="date" placeholder="Start Time" [(ngModel)]="model.fStartTimeAtd" required #startTime="ngModel" id="startTime" name="startTime" (change)="addOneHour()" [ngClass]="{ 'error': isSubmit && startTime.invalid }">
                    <div *ngIf="isSubmit && startTime.invalid">
                      <div class="text-danger"> Start Time is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6">
                  <div class="form-group">
                    <label for="Subject">End Time<span class="text-danger">*</span></label>
                    <input type="time" class="form-control" aria-describedby="date" placeholder="End Time" [(ngModel)]="model.fEndTimeAtd" required #endTime="ngModel" id="endTime" name="endTime" [ngClass]="{ 'error': isSubmit && endTime.invalid }" [disabled]="isETimeDisabled">
                    <div *ngIf="isSubmit && endTime.invalid">
                      <div class="text-danger"> End Time is required</div>
                    </div>
                    <div *ngIf="getErrorStatus()"
                         class="text-danger">
                      <div><small>End time must be greater than start time</small></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6">
                  <div class="form-group">
                    <label for="Subject">Meeting Type<span class="text-danger">*</span></label>
                    <ng-select [items]="meetingTypeList" class="form-control p-0 fixed-hgt"
                               bindLabel="meetingName"
                               appendTo="body"
                               bindValue="meetingTypeUno"
                               required #meetingType="ngModel"
                               [(ngModel)]="model.meetingTypeUno"
                               id="meetingType"
                               name="meetingType"
                               [ngClass]="{ 'error': isSubmit && meetingType.invalid }"
                               [multiple]="false"
                               [searchable]="true"
                               [virtualScroll]="true"
                               [minTermLength]="1"
                               placeholder="Meeting Type">
                    </ng-select>
                    <div *ngIf="isSubmit && meetingType.invalid">
                      <div class="text-danger"> Meeting Type is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6">
                  <div class="form-group">
                    <label for="Subject">Meeting Room</label>

                    <input list="meetingRoomNameId" #meetingRoomName="ngModel" class="form-control"
                           [(ngModel)]="model.meetingRoomName"
                           placeholder="Meeting Room"
                           id="meetingRoomName"
                           name="meetingRoomName">
                    <datalist id="meetingRoomNameId">
                      <option *ngFor="let item of meetingRoomList" [value]="item.meetingRoomName">{{item.meetingRoomName}}</option>
                    </datalist>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [value]="model.impCheck" #impCheck="ngModel"
                           [(ngModel)]="model.impCheck"
                           id="impCheck"
                           name="impCheck">
                    <label class="form-check-label" for="impCheck">
                      Mark as Important
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [value]="model.delegateCheck" #delegateCheck="ngModel"
                           [(ngModel)]="model.delegateCheck"
                           id="delegateCheck"
                           name="delegateCheck">
                    <label class="form-check-label" for="delegateCheck">
                      Confidential meeting
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-4 py-3 h-100vh border-left" *ngIf="isMeetingEdit">
            <h4>Tracking</h4>
            <div class="list-bullet">
              <ul class="list-group my-3 mx-2">
                <li [ngClass]="model.published==1?'active':''" *ngIf="model.published==1 ">
                  Published<br>
                  <small class="text-muted"></small>
                </li>
                <!--<li [ngClass]="model.published==5?'active':''" *ngIf="model.published==1 || model.published>4 ">
                  Approved<br>
                  <small class="text-muted"></small>
                </li>-->
                <li *ngIf="approver!=null && approver.signImage!=''&& approver.signImage!=null">
                  Approved: {{approver.nameAtd}}<br />
                  <small *ngIf="approver!=null && approver.signImage!=''&& approver.signImage!=null" class="text-muted"> {{approver.modifiedOn |  date:'dd/MM/yyyy hh:mm a'}}</small>

                </li>
                <li [ngClass]="model.published==4?'active':''" *ngIf="model.published==4 ">

                  <small class="text-muted text-info position-relative position-top-minus-5">Pending for Approval: {{approver.nameAtd}} </small>
                </li>
                <li [ngClass]="model.published==3?'active':''" *ngIf="model.published==3 ">
                  Reviewed and Waiting for Approval Request<br>
                  <small class="text-muted"></small>
                </li>
                <li *ngFor="let item of reviewerList; let i = index ">
                  <span *ngIf="model.published==1|| model.published>1">


                    <!--<span class="text text-dark">{{i+1}} . {{item.nameAtd}}</span><br />-->
                    <span *ngIf="item.signImage!=''&& item.signImage!=null">
                      Reviewed: {{item.nameAtd}}<br>
                      <small *ngIf=" item.signImage!=''&& item.signImage!=null" class="text-muted">  {{item.modifiedOn |  date:'dd/MM/yyyy hh:mm a'}}</small>
                    </span>
                    <small *ngIf=" item.signImage==''|| item.signImage==null" class="text-muted text-warning position-relative position-top-minus-5">Pending for Review : {{item.nameAtd}}</small>
                  </span>
                  <span *ngIf="model.published==0 && item.role == 'Reviewer'">

                    <small *ngIf=" item.signImage==''|| item.signImage==null" class="text-muted text-warning position-relative position-top-minus-5">Pending for Review: {{item.nameAtd}}</small>
                  </span>
                </li>
                <!--<li [ngClass]="model.published==2?'active':''" *ngIf="model.published==1|| model.published>1">
                  Under Review<br>
                  <small class="text-muted"></small>
                </li>-->
                <li>
                  MOM Created: {{model.initiatedBy}}<br>
                  <small class="text-muted">{{model.createDate |  date:'dd/MM/yyyy hh:mm a'}}</small>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-4 py-3 h-100vh border-left" *ngIf="!isMeetingEdit">
            <h4>Tracking</h4>
            <div class="list-bullet">
              <ul class="list-group my-3 mx-2">

                <li class="active" *ngIf="show">
                  Draft<br>
                  <small class="text-muted"></small>
                </li>
                <li *ngIf="show">
                  Meeting Minutes Created: <span class="f-bold-dubai">{{model.initiatedBy}}</span><br>
                  <small class="text-muted">{{model.createDate |  date:'dd/MM/yyyy hh:mm a'}}</small>
                </li>
                <li class="active" *ngIf="!show">
                  Started<br>
                  <small class="text-muted"></small>
                </li>
                <li *ngIf="!show">
                  Meeting Minutes Initiated: <span class="f-bold-dubai">{{model.initiatedBy}}</span><br>
                  <small class="text-muted">{{model.createDate |  date:'dd/MM/yyyy'}}</small>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>


      <div class="tab-pane fade" [ngClass]="{ 'active show':selTab2}" id="attendees" role="tabpanel" aria-labelledby="attendees-tab">
        <div class="row">
          <div class="col-md-12">
            <div class="text-right py-3">
              <a class="btn btn-sm btn-outline-success" (click)="exportAttendee()"><i class="ti ti-export"></i> Export Attendees</a>
            </div>
            <div>
              <ul class="nav nav-border-tabs" id="myTab" role="tablist">
                <li class=" f-bold-dubai text-secondary pr-2">Add Attendee :</li>
                <li class="nav-item"><a class="nav-link" id="internal-tab" (click)="onChangesubTab('internal')" [ngClass]="{ 'active':addTab1}"  data-toggle="tab" href="#internal" role="tab" aria-controls="internal" aria-selected="true">Internal</a></li>
                <li class="nav-item"><a class="nav-link" id="external-tab" (click)="onChangesubTab('external')" [ngClass]="{ 'active':addTab2}" data-toggle="tab" href="#external" role="tab" aria-controls="attendees" aria-selected="false">External</a></li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade" [ngClass]="{ 'active show':addTab1}" id="internal" role="tabpanel" aria-labelledby="internal-tab">
                  <form name="ia" id="ia" #ia="ngForm" (ngSubmit)="onSubmitInternal(ia,'Attendee',selectedInternalUser)" novalidate>
                    <div class="row py-2 custom-tab">
                      <div class="col-md-4">
                        <div class="form-group">
                          <ng-select [items]="UserList" class="form-control p-0"
                                     bindLabel="fullAttendeeName"
                                     bindValue="userselUno"
                                     required #selectInternalUser="ngModel"
                                     [(ngModel)]="selectedInternalUser"
                                     id="selectInternalUser"
                                     name="selectInternalUser"
                                     [ngClass]="{ 'error':isSubmitInternal  && selectInternalUser.invalid }"
                                     [multiple]="false"
                                     [searchable]="true"
                                     [searchFn]="customSearchFn"
                                     [virtualScroll]="true"
                                     [minTermLength]="3"
                                     placeholder="Search attendees by Name or PR or Email">
                            <ng-template ng-option-tmp let-item="item">
                              <div class="line">{{item.fullAttendeeName}}</div>
                              <div class="line-email">{{item.emailAtd}}</div>
                              <div class="line-designation">{{item.designation}} {{item.division}}</div>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="isSubmitInternal && selectInternalUser.invalid">
                            <div class="text-danger"> Select the user</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <button class="btn btn-success px-4"> Add </button>
                          <!--<button type="button" (click)="cancelAttendee()" class="btn text-secondary bg-white border-0 ml-2"><i class="la la-times"></i> Cancel</button>-->
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="tab-pane fade" [ngClass]="{ 'active show':addTab2}" id="external" role="tabpanel" aria-labelledby="external-tab">
                  <form name="eu" id="eu" #eu="ngForm" (ngSubmit)="onSubmitExternal(eu)" novalidate>
                    <div class="row py-2 custom-tab">
                      <div class="col-md-2">
                        <div class="form-group">
                          <input class="form-control" type="text" placeholder="Name" required #uname="ngModel"
                                 [(ngModel)]="attendeeModel.nameAtd"
                                 id="uname"
                                 name="uname"
                                 [ngClass]="{ 'error':isSubmitExternal  && uname.invalid }">
                        </div>
                        <div *ngIf="isSubmitExternal && uname.invalid">
                          <div class="text-danger"> Name is required</div>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <input class="form-control" type="text" placeholder="Organization" required #organization="ngModel"
                                 [(ngModel)]="attendeeModel.companyAtd"
                                 id="organization"
                                 name="organization"
                                 [ngClass]="{ 'error':isSubmitExternal  && organization.invalid }">
                        </div>
                        <div *ngIf="isSubmitExternal && organization.invalid">
                          <div class="text-danger"> Organization is required</div>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <input class="form-control" type="email" placeholder="Email" required #emailAddr="ngModel"
                                 [(ngModel)]="attendeeModel.emailAtd"
                                 id="emailAddr"
                                 name="emailAddr"
                                 pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                                 [ngClass]="{ 'error':isSubmitExternal  && emailAddr.invalid }">
                        </div>
                        <div *ngIf="isSubmitExternal && emailAddr.invalid">
                          <div class="text-danger"> Email is required</div>
                        </div>
                        <div *ngIf="emailAddr.touched">

                          <p class="text-danger" *ngIf="emailAddr.errors?.pattern">This is not a valid Email!!!</p>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <input class="form-control" type="text" placeholder="Contact Number" #contactno="ngModel"
                                 [(ngModel)]="attendeeModel.contactAtd"
                                 id="contactno"
                                 name="contactno">
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <input class="form-control" type="text" placeholder="Designation" required #designation="ngModel"
                                 [(ngModel)]="attendeeModel.designation"
                                 id="designation"
                                 name="designation"
                                 [ngClass]="{ 'error':isSubmitExternal  && designation.invalid }">
                        </div>
                        <div *ngIf="isSubmitExternal && designation.invalid">
                          <div class="text-danger"> Designation is required</div>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <button class="btn btn-success px-4"> Add</button>
                          <!--<button type="button" (click)="cancelAttendee()" class="btn text-secondary bg-white border-0 ml-2"> Cancel</button>-->
                        </div>
                      </div>

                    </div>
                  </form>
                </div>
              </div>

              <div class="form-group float-right position-relative">
                <div class="input-group">
                    <input type="text" class="form-control pr-4" id="formGroupExampleInput2" placeholder="Search by Name or Status" [(ngModel)]="searchText" (keyup)="searchGrid()" [ngModelOptions]="{standalone: true}">
                    <div class="input-group-append">
                        <span class="input-group-text" style="border: none !important;">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
                </div>
            </div>
              <div class="table-popover-view table-responsive-lg" style="padding-bottom: 30px;">
                <table class="table border-0 table-border-td">
                  <thead>
                    <tr>
                      <th scope="col" class="border-0 w-35">Name</th>
                      <th scope="col" class="border-0">PR&nbsp;Number</th>
                      <th scope="col" class="border-0 w-25">Designation</th>
                      <th scope="col" class="border-0">Attendance</th>
                      <th scope="col" class="border-0">Role</th>
                      <th scope="col" class="border-0 px-4">Action</th>
                    </tr>
                  </thead>
                  <tbody cdkDropList (cdkDropListDropped)="onDrop($event)">
                   
                    <ng-container *ngIf="searchList == null || searchList.length <= 0">
                      <tr *ngFor="let item of attendeeList" cdkDrag cdkDragLockAxis="y">
                        <td class="border-left position-relative">
                          <div id="{{item.attendeesUnoAtd}}" class="d-none card mb-0 bg-white p-3 border profiledetails">
                            <span class="position-absolute position-right-10 close-card pointer" (click)="closeCard(item.attendeesUnoAtd)"><i class="la la-close"></i></span>
                            <div class="row profile-scroll">
                              <div class="col-md-3 pr-0">
                                <span><img class="img-fluid rounded-circle wh-80" [src]="item.picture" alt="Profile" /></span>
                              </div>
                              <div class="col-md-9">
                                <div class="border-bottom">
                                  <h5 class="mb-0">{{item.nameAtd}}</h5>
                                  <p class="py-0 my-0 text-secondary">
                                    {{item.designation}}<br>
                                    <small><i class="la la-id-badge"></i>   {{item.prNumberAtd}}</small>
                                  </p>
                                </div>
                                <h5 class="pt-2 mb-0">Contact information</h5>
                                <div class="row text-secondary">
                                  <div class="col-md-4"><i class="la la-envelope"></i> Email</div>
                                  <div class="col-md-8"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
                                </div>
                                <div class="row text-secondary">
                                  <div class="col-md-4"><i class="la la-comments"></i> Chat</div>
                                  <div class="col-md-8"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
                                </div>
                                <div class="row text-secondary">
                                  <div class="col-md-4"><i class="la la-phone-square"></i>Phone</div>
                                  <div class="col-md-8">{{item.contactAtd==0?'-':item.contactAtd}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <span class="bg-light rounded-circlebg-light rounded-circle circle-40 py-2 px-1 text-brown f-bold-dubai mx-2 border pointer text-center" (click)="profileCard(item.attendeesUnoAtd)">{{getShortName(item.nameAtd)}}</span> <span (click)="profileCard(item.attendeesUnoAtd)" class="pointer"> {{item.nameAtd}}</span>
                        </td>
                        <td>{{item.prNumberAtd}}</td>
                        <td>{{item.designation}}</td>
                        <td>
                          <select [(ngModel)]="item.status" #status="ngModel"
                                  id="status" (change)="ChangeAttendeeStatus(item)"
                                  name="status" class="custom-select border-0">
                            <option value="Present">Present </option>
                            <option value="On Behalf">{{'On Behalf ' + ((item.status=='On Behalf')? '-('+item.apologizedReason+')':'') }}</option>
                            <option value="Absent">Absent</option>
                            <option value="Apologized">Apologized</option>
                            <option value="External">External</option>
                          </select>
                        </td>
                        <td>
                          <select class="custom-select border-0" [(ngModel)]="item.role" #role="ngModel"
                                  (change)="UpdateAttendees('role',item.role,item)"
                                  id="role" name="role">
                            <option value="Organizer">Organizer </option>
                            <option value="Attendee">Attendee</option>
                            <option value="Guest">Guest</option>
                            <option value="Has Action (Non-attendee)">Has Action (Non-attendee)</option>
                          </select>
                        </td>
  
                        <td class="border-right">
                          <span class="d-block">
                            <a *ngIf="item.status=='Apologized'" (click)="attendeeReason(item)" [title]="item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-info-circle fa-lg"></i></a>
                            <a *ngIf="item.status=='On Behalf'" (click)="attendeeReason(item)" [title]="item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-user fa-lg"></i></a>
                            <a *ngIf="(item.prNumberAtd==null || item.prNumberAtd=='')" title="Edit" (click)="editAttendee(item)" class="text-primary m-0 text-right d-inline"><i class="la la-edit fa-lg"></i></a>
                            <a *ngIf="item.userselUno!=loginUserId" title="Delete" (click)="delAttendee(item.attendeesUnoAtd)" class="text-danger m-0 text-right"><i class="la la-trash fa-lg"></i></a>
                          </span>
                        </td>
                      </tr>
                    </ng-container>

                    <ng-container *ngIf="searchList != null && searchList.length > 0">
                      <tr *ngFor="let item of searchList" cdkDrag cdkDragLockAxis="y">
                        <td class="border-left position-relative">
                          <div id="{{item.attendeesUnoAtd}}" class="d-none card mb-0 bg-white p-3 border profiledetails">
                            <span class="position-absolute position-right-10 close-card pointer" (click)="closeCard(item.attendeesUnoAtd)"><i class="la la-close"></i></span>
                            <div class="row profile-scroll">
                              <div class="col-md-3 pr-0">
                                <span><img class="img-fluid rounded-circle wh-80" [src]="item.picture" alt="Profile" /></span>
                              </div>
                              <div class="col-md-9">
                                <div class="border-bottom">
                                  <h5 class="mb-0">{{item.nameAtd}}</h5>
                                  <p class="py-0 my-0 text-secondary">
                                    {{item.designation}}<br>
                                    <small><i class="la la-id-badge"></i>   {{item.prNumberAtd}}</small>
                                  </p>
                                </div>
                                <h5 class="pt-2 mb-0">Contact information</h5>
                                <div class="row text-secondary">
                                  <div class="col-md-4"><i class="la la-envelope"></i> Email</div>
                                  <div class="col-md-8"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
                                </div>
                                <div class="row text-secondary">
                                  <div class="col-md-4"><i class="la la-comments"></i> Chat</div>
                                  <div class="col-md-8"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
                                </div>
                                <div class="row text-secondary">
                                  <div class="col-md-4"><i class="la la-phone-square"></i>Phone</div>
                                  <div class="col-md-8">{{item.contactAtd==0?'-':item.contactAtd}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <span class="bg-light rounded-circlebg-light rounded-circle circle-40 py-2 px-1 text-brown f-bold-dubai mx-2 border pointer text-center" (click)="profileCard(item.attendeesUnoAtd)">{{getShortName(item.nameAtd)}}</span> <span (click)="profileCard(item.attendeesUnoAtd)" class="pointer"> {{item.nameAtd}}</span>
                        </td>
                        <td>{{item.prNumberAtd}}</td>
                        <td>{{item.designation}}</td>
                        <td>
                          <select [(ngModel)]="item.status" #status="ngModel"
                                  id="status" (change)="ChangeAttendeeStatus(item)"
                                  name="status" class="custom-select border-0">
                            <option value="Present">Present </option>
                            <option value="On Behalf">{{'On Behalf ' + ((item.status=='On Behalf')? '-('+item.apologizedReason+')':'') }}</option>
                            <option value="Absent">Absent</option>
                            <option value="Apologized">Apologized</option>
                            <option value="External">External</option>
                          </select>
                        </td>
                        <td>
                          <select class="custom-select border-0" [(ngModel)]="item.role" #role="ngModel"
                                  (change)="UpdateAttendees('role',item.role,item)"
                                  id="role" name="role">
                            <option value="Organizer">Organizer </option>
                            <option value="Attendee">Attendee</option>
                            <option value="Guest">Guest</option>
                            <option value="Has Action (Non-attendee)">Has Action (Non-attendee)</option>
                          </select>
                        </td>
  
                        <td class="border-right">
                          <span class="d-block">
                            <a *ngIf="item.status=='Apologized'" (click)="attendeeReason(item)" [title]="item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-info-circle fa-lg"></i></a>
                            <a *ngIf="item.status=='On Behalf'" (click)="attendeeReason(item)" [title]="item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-user fa-lg"></i></a>
                            <a *ngIf="(item.prNumberAtd==null || item.prNumberAtd=='')" title="Edit" (click)="editAttendee(item)" class="text-primary m-0 text-right d-inline"><i class="la la-edit fa-lg"></i></a>
                            <a *ngIf="item.userselUno!=loginUserId" title="Delete" (click)="delAttendee(item.attendeesUnoAtd)" class="text-danger m-0 text-right"><i class="la la-trash fa-lg"></i></a>
                          </span>
                        </td>
                      </tr>
                    </ng-container>

                    <!-- <br><br><br> -->
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-center pb-5" *ngIf="!disableMoreAtd" (click)="getAttendeeList()"><a class="btn btn-sm btn-outline-secondary">Load More..</a></div>
          </div>
        </div>

      </div>



      <div class="tab-pane fade" [ngClass]="{ 'active show':selTab3}" id="Workflow" role="tabpanel" aria-labelledby="Workflow-tab">
        <div class="row">
          <div class="col-md-12 px-1">
            <h5 class="text-secondarytext-secondary custom-tab f-bold-dubai text-secondary py-3 px-3">Set the Workflow:</h5>
            <div class="work-flow-section col-md-12">
              <div class="work-flow-status form-row">
                <div class="step step-one active">
                  <span class="icon"></span>
                  <span class="text f-bold-dubai">Initiator</span>
                  <div class="form-group pt-3">
                    <input type="text" readonly [value]="model.initiatedBy" class="form-control col-md-10">
                  </div>
                </div>
                <div class="step step-two active">
                  <span class="icon"></span>
                  <span class="text f-bold-dubai"> Reviewer</span>
                  <div class="form-group">
                    <form name="rwForm" id="rwForm" #rwForm="ngForm" class="pt-3" novalidate>
                      <div class="form-group pb-3" *ngIf="reviewerList && reviewerList.length!=5">
                        <ng-select [items]="UserList" class="form-control col-md-10 p-0"
                                   bindLabel="fullAttendeeName"
                                   bindValue="userselUno"
                                   required #selectReviewer="ngModel"
                                   [(ngModel)]="selectedReviewer"
                                   id="selectReviewer"
                                   name="selectReviewer"
                                   [ngClass]="{ 'error':isSubmitReview  && selectReviewer.invalid }"
                                   [multiple]="false"
                                   [searchable]="true"
                                   [searchFn]="customSearchFn"
                                   [virtualScroll]="true"
                                   [minTermLength]="3"
                                   (change)="onSubmitReviewer(rwForm,'Reviewer',selectedReviewer);"
                                   placeholder=" Select the Reviewer">
                          <ng-template ng-option-tmp let-item="item">
                            <div class="line">{{item.fullAttendeeName}}</div>
                            <div class="line-email">{{item.emailAtd}}</div>
                            <div class="line-designation">{{item.designation}} {{item.division}}</div>
                          </ng-template>
                        </ng-select>
                        <div *ngIf="isSubmitReview && selectReviewer.invalid">
                          <div class="text-danger"> Select the Reviewer</div>
                        </div>
                      </div>
                      <!--<div class="form-group" *ngIf="reviewerList && reviewerList.length!=5">
        <a class="text-secondary pointer my-2 d-block" (click)="onSubmitReviewer(rwForm,'Reviewer',selectedReviewer);"><i class="la la-plus"></i> Add Reviewer</a>
      </div>-->
                      <div class="form-group pb-3" *ngFor="let item of reviewerList">
                        <span class="d-inline-flex col-md-12 pl-0 position-relative"> <input type="text" [value]="item.nameAtd" readonly class="form-control"> <a (click)="delAttendee(item.attendeesUnoAtd)" class="text-secondary m-1 text-right position-absolute position-right-15 position-top-5 bg-lighty-grey"><i class="la la-close fa-lg"></i></a></span>
                      </div>

                    </form>
                  </div>

                  


                  </div>
                  <div class="step step-three active">
                    <span class="icon"></span>
                    <span class="text f-bold-dubai"> Approver </span>
                    <div class="form-group pt-3">
                      <form name="aprForm" id="aprForm" #aprForm="ngForm" novalidate>

                        <div class="form-group" *ngIf="approver==null">
                          <ng-select [items]="UserList" class="form-control col-md-10 p-0"
                                     bindLabel="fullAttendeeName"
                                     bindValue="userselUno"
                                     required #selectApprover="ngModel"
                                     [(ngModel)]="selectedApprover"
                                     id="selectApprover"
                                     name="selectApprover"
                                     [ngClass]="{ 'error':isSubmitApprover  && selectApprover.invalid }"
                                     [multiple]="false"
                                     [searchable]="true"
                                     [searchFn]="customSearchFn"
                                     [virtualScroll]="true"
                                     [minTermLength]="3"
                                     (change)="onSubmitApprover(aprForm,'Approver',selectedApprover);"
                                     placeholder=" Select the Approver">
                            <ng-template ng-option-tmp let-item="item">
                              <div class="line">{{item.fullAttendeeName}}</div>
                              <div class="line-email">{{item.emailAtd}}</div>
                              <div class="line-designation">{{item.designation}} {{item.division}}</div>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="isSubmitApprover && selectApprover.invalid">
                            <div class="text-danger"> Select the Approver</div>
                          </div>
                        </div>
                        <div class="form-group " *ngIf="approver!=null">
                          <span class="d-inline-flex col-12 pl-0 position-relative"> <input type="text" [value]="approver.nameAtd" readonly class="form-control"> <a (click)="delAttendee(approver.attendeesUnoAtd)" class="text-secondary m-1 text-right position-absolute position-right-15 position-top-5 bg-lighty-grey"><i class="la la-close fa-lg"></i></a></span>
                        </div>
                        <!--<div class="form-group" *ngIf="approver==null">
          <a class="text-secondary pointer my-2 d-block" (click)="onSubmitApprover(aprForm,'Approver',selectedApprover);"><i class="la la-plus"></i> Add Approver</a>
        </div>-->
                      </form>
                    </div>
                  </div>
                  <div class="step step-four active"> <span class="icon"></span> <span class="text f-bold-dubai">Publish</span> </div>
                </div>
            </div>
            <div class="col-md-3 px-2 mx-1">
              <div class="form-group">
                <label for="follow-up">Follow-up</label>
                <form name="flwForm" id="flwForm" #flwForm="ngForm" novalidate>

                  <div class="form-group pt-3" *ngIf="followerList && followerList.length!=5">
                    <ng-select [items]="UserList" class="form-control col-md-10 p-0"
                               bindLabel="fullAttendeeName"
                               bindValue="userselUno"
                               required #selectFollower="ngModel"
                               [(ngModel)]="selectedFollower"
                               id="selectFollower"
                               name="selectFollower"
                               [ngClass]="{ 'error':isSubmitFollower  && selectFollower.invalid }"
                               [multiple]="false"
                               [searchable]="true"
                               [searchFn]="customSearchFn"
                               [virtualScroll]="true"
                               [minTermLength]="3"
                               (change)="onSubmitFollower(flwForm,'Follower',selectedFollower);"
                               placeholder=" Select the Follower">
                      <ng-template ng-option-tmp let-item="item">
                        <div class="line">{{item.fullAttendeeName}}</div>
                        <div class="line-email">{{item.emailAtd}}</div>
                        <div class="line-designation">{{item.designation}} {{item.division}}</div>
                      </ng-template>
                    </ng-select>
                    <div *ngIf="isSubmitFollower && selectFollower.invalid">
                      <div class="text-danger"> Select the Follower</div>
                    </div>
                  </div>
                  <div class="form-group " *ngFor="let item of followerList">
                    <span class="d-inline-flex"> <input type="text" [value]="item.nameAtd" readonly class="form-control col-md-8"> <a (click)="delAttendee(item.attendeesUnoAtd)" class="text-danger col-md-1 m-1 text-right"><i class="la la-trash fa-lg"></i></a></span>
                  </div>
                  <!--<div class="form-group" *ngIf="followerList && followerList.length!=5">
                    <a class="text-secondary pointer my-2 d-block" (click)="onSubmitFollower(flwForm,'Follower',selectedFollower);"><i class="la la-plus"></i> Add Follow-up</a>
                  </div>-->
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-8 py-4 px-3 mx-1">
            <h5 class="text-secondarytext-secondary custom-tab f-bold-dubai text-secondary py-3">Workflow Settings:</h5>
            <ul class="list-group list-group-flush">
              <li class="list-group-item mb-1 px-0" *ngIf="((approver ==null)&&(reviewerList ==null || reviewerList.length==0))">
                Publish without Review and Approve<br>
                <small class="text-secondary">You will be signed as the reviewer and approver</small>
                <div class="custom-control custom-switch custom-switch-md custom-green-swith float-right">
                  <input type="checkbox" [(ngModel)]="model.workFlowCondition1" (change)="model.workFlowCondition2=false;model.workFlowCondition3=false;model.workFlowCondition4=false;onSubmitWorkFlow();" class="custom-control-input" id="customSwitch1">
                  <label class="custom-control-label" for="customSwitch1"></label>
                </div>

              </li>
              <li class="list-group-item mb-1 px-0">
                Auto-send to Approver after Reviewed (by all reviewers)
                <div class="custom-control custom-switch custom-switch-md custom-green-swith float-right">
                  <input type="checkbox" [(ngModel)]="model.workFlowCondition2" (change)="model.workFlowCondition1=false;onSubmitWorkFlow();" [readonly]="model.workFlowCondition1" class="custom-control-input" id="customSwitch4">
                  <label class="custom-control-label" for="customSwitch4"></label>
                </div>

              </li>
              <li class="list-group-item mb-1 px-0">
                Auto-publish after Approved
                <div class="custom-control custom-switch custom-switch-md custom-green-swith float-right">
                  <input type="checkbox" (change)="model.workFlowCondition1=false;model.workFlowCondition4=false;onSubmitWorkFlow();" [(ngModel)]="model.workFlowCondition3" class="custom-control-input" id="customSwitch2">
                  <label class="custom-control-label" for="customSwitch2"></label>
                </div>
              </li>
              <li class="list-group-item border-bottom px-0">
                Send for signature to all attendees<br>
                <small class="text-secondary">All attendees will be required to review and sign the MOM before it can published</small>
                <div class="custom-control custom-switch custom-switch-md custom-green-swith float-right">
                  <input type="checkbox" [(ngModel)]="model.workFlowCondition4" (change)="model.workFlowCondition1=false;model.workFlowCondition3=false;onSubmitWorkFlow();" class="custom-control-input" id="customSwitch3">
                  <label class="custom-control-label" for="customSwitch3"></label>
                </div>
              </li>
            </ul>
          </div>
          <!--<div class="col-md-12 text-right">
            <button type="button" class="btn btn-outline-secondary m-2 f-bold-dubai px-4" (click)="onSubmitWorkFlow()">Save</button>
          </div>-->
        </div>
      </div>


      <div class="tab-pane fade" [ngClass]="{ 'active show':selTab4}" id="actionspoints" role="tabpanel" aria-labelledby="actionspoints-tab">
        <div class="row">
          <div class="col-md-12 px-3">
            <div class="text-right py-3">
              <a class="btn btn-outline-success btn-sm py-1 mb-1" (click)="exportActionPoint()"><i class="ti ti-export"></i> Export Action</a>
            </div>
            <div class="py-2">
              <a class="bg-lighty-grey border-0 d-block p-2 rounded text-secondary hide-text-decoration pointer text-left" (click)="openAddActionPoint()"><i class="la la-plus"></i> Add Action Point</a>
            </div>
            <div class="custom-tab">

              <div class="my-3">
                <div class="border rounded bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="mainActionPointList.length ===0">
                  <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
                  <h5 class="py-4 text-center">No Data Available</h5>
                </div>
                <div cdkDropList (cdkDropListDropped)="onDropAction($event)">
                  <div class="border rounded" *ngFor="let agenda of mainActionPointList" cdkDrag cdkDragLockAxis="y">
                    <div class="pt-2 position-relative">
                      <div class="px-3 pb-2">
                        <h6 class="card-title d-inline f-bold-dubai pr-6-p hinde-p-mb" [innerHTML]="agenda.note"></h6>
                        <div class="card-controls position-absolute position-top-0 position-right-15 text-secondary pt-1">
                          <ul class="list-inline hide-arrow-drop mb-0">
                            <!--<li class="list-inline-item m-0 nav-item px-1 pointer"><a title="Edit" (click)="openEditActionPoint(agenda)"><i class="la la-edit fa-lg text-primary"></i></a></li>-->
                            <li class="list-inline-item m-0 nav-item px-0 pointer upload-btn-wrapper position-bottom-minus-3"><a class="" title="Attach File"><i class="fa mr-1 fa-paperclip icon-rotate-140 position-relative position-bottom-minus-5"></i><input type="file" id="myActionfile" class="file-upload" name="myActionfile" (change)="actionPointFileInput($event.target.files,agenda)" /> </a></li>
                            <li class="list-inline-item m-0 nav-item pr-1 pointer" (click)="openFileList(agenda.agendaUno,'ActionPoint')" title="View File">
                              ({{getFileList(agenda.agendaUno,'ActionPoint')}})
                            </li>
                            <li class="list-inline-item m-0 nav-item"><a title="Delete" (click)="deleteActionPoints(agenda)"><i class="la la-trash-o fa-lg text-danger"></i></a></li>
                            <li class="list-inline-item m-0 nav-item all-scroll">
                              <a title="Reorder" class="nav-link p-0 all-scroll"><i class="la la-ellipsis-v fa-lg w-7 all-scroll"></i><i class="la la-ellipsis-v fa-lg w-7 all-scroll"></i></a>
                              <!--<ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <li><a ngbDropdownItem (click)="openEditActionPoint(agenda)"><i class="fa fa-edit"></i> Edit</a></li>
                                <li class="upload-btn-wrapper"><a ngbDropdownItem><i class="fa mr-1 fa-paperclip"></i>Attach File <input type="file" id="myActionfile" class="file-upload" name="myActionfile" (change)="actionPointFileInput($event.target.files,agenda)" /> </a></li>
                                <li><a ngbDropdownItem (click)="deleteActionPoints(agenda)"><i class="fa fa-close"></i> Delete</a></li>
                              </ul>-->
                            </li>
                          </ul>
                        </div>
                        <div class="row mt-2">
                          <div class="col-lg-3 col-md-4 col-sm-4">
                            <div class="form-group">
                              <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                  <div class="form-control border-0"><i class="la la-calendar-check-o fa-lg"></i></div>
                                </div>
                                <input type="text" class="form-control pointer" title="Edit" (click)="openEditActionPoint(agenda,true,'Action')" readonly value="{{agenda.dueDate |  date:'dd/MM/yyyy'}}" id="agendaDueDate" placeholder="Set Due Date">
                              </div>

                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4 col-sm-4">
                            <div class="form-group">

                              <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                  <div class="form-control border-0"><i class="la la-user-alt fa-lg"></i></div>
                                </div>
                                <input type="text" title="Edit" (click)="openEditActionPoint(agenda,true,'Action')" class="form-control pointer" readonly [(ngModel)]="agenda.userName" placeholder="Assign Responsibility">
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-3 px-0">
                            <div class="gray-radius-btn d-sm-flex py-2 float-sm-left text-white pointer" title="Edit" (click)="openEditActionPoint(agenda,true,'Action')" [ngClass]="gerPriortyColor(agenda.priority)">
                              <i class="la la-info-circle fa-lg mx-1"></i>
                              {{agenda.priority}}
                            </div>
                          </div>
                        </div>
                        <a class="pt-2 pb-1 text-primary d-block" (click)="opensubActionPoint(agenda,'Sub-point')"><i class="la la-plus"></i> Add a sub-point</a>
                      </div>
                      <div class="pt-2 px-4 border-top bg-light position-relative" *ngFor="let subAction of getSubItems(agenda)">
                        <h6 class="card-title text-secondary f-regular-dubai pr-md-5 pt-md-0 pt-3 hinde-p-mb" [innerHTML]="subAction.note"></h6>
                        <div class="card-controls position-absolute position-top-10 position-right-15 text-secondary">
                          <ul class="list-inline hide-arrow-drop mb-0">
                            <li class="list-inline-item mx-1">
                              <a class="text-danger" (click)="deleteActionPoints(subAction)"><i class="la la-trash fa-lg"></i></a>
                            </li>
                            <!--<li class="list-inline-item m-0">
                              <a class="text-primary" (click)="openEditActionPoint(subAction)"><i class="la la-edit fa-lg"></i></a>
                            </li>-->
                          </ul>
                        </div>
                        <div class="row mt-2">
                          <div class="col-lg-3 col-md-4 col-sm-4">
                            <div class="form-group">
                              <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                  <div class="form-control border-0"><i class="la la-calendar-check-o fa-lg"></i></div>
                                </div>
                                <input type="text" class="form-control pointer" title="Edit" (click)="openEditActionPoint(subAction,true,'Sub')" readonly value="{{subAction.dueDate |  date:'dd/MM/yyyy'}}" placeholder="Set Due Date">
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4 col-sm-4">
                            <div class="form-group">

                              <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                  <div class="form-control border-0"><i class="la la-user-alt fa-lg"></i></div>
                                </div>
                                <input title="Edit" type="text" class="form-control pointer" (click)="openEditActionPoint(subAction,true,'Sub')" readonly [(ngModel)]="subAction.userName" placeholder="Assign Responsibility">
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-3 px-0">
                            <div title="Edit" class="gray-radius-btn d-sm-flex py-2 float-sm-left text-white pointer" (click)="openEditActionPoint(subAction,true,'Sub')" [ngClass]="gerPriortyColor(subAction.priority)">
                              <i class="la la-info-circle fa-lg mx-1"></i>
                              {{subAction.priority}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" [ngClass]="{ 'active show':selTab6}" id="discussion" role="tabpanel" aria-labelledby="discussion-tab">
        <div class="row">

          <div class="col-md-12 px-3">
            <div class="text-right py-3">
              <a class="btn btn-outline-success btn-sm m-2" (click)="exportDiscussion()"><i class="ti ti-export"></i> Export Discussion</a>
            </div>
            <div class="py-2">
              <a class="bg-lighty-grey border-0 d-block p-2 rounded text-secondary hide-text-decoration pointer text-left" (click)="openAddActionPoint(false)"><i class="la la-plus"></i> Add Discussion</a>
            </div>
            <div class="custom-tab">
              <div class="my-3" cdkDropList (cdkDropListDropped)="onDropDiscussion($event)">
                <div class="border rounded" *ngFor="let agenda of mainDiscussionPointList" cdkDrag cdkDragLockAxis="y">
                  <div class="pt-2 px-3 pb-3 border-bottom position-relative">
                    <br>
                    <h6 class="card-title d-inline f-bold-dubai pr-6-p hinde-p-mb" [innerHTML]="agenda.note"></h6>
                    <div class="card-controls position-absolute position-top-0 position-right-15 text-secondary">
                      <ul class="list-inline hide-arrow-drop mb-0">
                        <li class="list-inline-item m-0 nav-item pointer text-primary px-1"><a title="Edit" (click)="openEditActionPoint(agenda,false)"><i class="la la-edit fa-lg"></i></a></li>
                        <li class="list-inline-item m-0 nav-item pointer upload-btn-wrapper pr-0 position-bottom-minus-3"><a><i class="fa mr-1 fa-paperclip icon-rotate-140 position-relative position-bottom-minus-5"></i><input type="file" id="myActionfile" class="file-upload" name="myActionfile" (change)="actionPointFileInput($event.target.files,agenda)" /></a></li>
                        <li class="list-inline-item m-0 nav-item pointer pr-1" title="View File" (click)="openFileList(agenda.agendaUno,'ActionPoint')">
                          ({{getFileList(agenda.agendaUno,'ActionPoint')}})
                        </li>
                        <li class="list-inline-item m-0 nav-item pointer pr-1"><a title="Delete" (click)="deleteActionPoints(agenda)"><i class="la la-trash fa-lg text-danger"></i></a></li>
                        <li class="list-inline-item m-0 nav-item">
                          <a title="Reorder" class="nav-link p-0"><i class="la la-ellipsis-v fa-lg w-7 all-scroll"></i><i class="la la-ellipsis-v fa-lg w-7 all-scroll"></i></a>
                          <!--<ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <li><a ngbDropdownItem (click)="openEditActionPoint(agenda,false)"><i class="fa fa-edit"></i> Edit</a></li>
                            <li class="upload-btn-wrapper"><a ngbDropdownItem><i class="fa mr-1 fa-paperclip"></i>Attach File <input type="file" id="myActionfile" class="file-upload" name="myActionfile" (change)="actionPointFileInput($event.target.files,agenda)" /> </a></li>
                            <li><a ngbDropdownItem (click)="deleteActionPoints(agenda)"><i class="fa fa-close"></i> Delete</a></li>
                          </ul>-->
                        </li>
                      </ul>
                    </div>

                    <!--<a class="pt-2 pb-3 text-primary d-block" (click)="opensubActionPoint(agenda,false)"><i class="la la-plus"></i> Add a sub-point</a>-->
                    <div class="pt-2 px-4 border-bottom bg-light" *ngFor="let subAction of getSubItems(agenda)">
                      <div class="row mt-2">
                        <div class="col-md-11 col-sm-10">
                          <span class="card-title d-inline text-secondary f-regular-dubai" [innerHTML]="subAction.note"></span>
                        </div>
                        <div class="col-md-1 col-sm-2">
                          <a class="text-danger pull-right" (click)="deleteActionPoints(subAction)"><i class="la la-trash fa-lg"></i></a>
                          <a class="text-primary pull-right pr-1" (click)="openEditActionPoint(subAction,false)"><i class="la la-edit fa-lg"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="border rounded bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="mainDiscussionPointList.length ===0">
          <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
          <h5 class="py-4 text-center">No Data Available</h5>
        </div>
      </div>

      <div class="tab-pane fade pb-6" [ngClass]="{ 'active show':selTab5}" id="files" role="tabpanel" aria-labelledby="files-tab">

        <div class="row">
          <div class="col-md-6 pb-70 order-first">
            <div class="form-group">
              <div class="col-md-12 pt-3 px-md-0">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" id="allMeeting" type="radio" value="0" name="meeting" checked (change)="changeFileFilter(0);isFileUpload=true;">
                  <label class="form-check-label" for="allMeeting">All</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" id="meeting" type="radio" value="1" name="meeting" (change)="changeFileFilter(1);isFileUpload=true;">
                  <label class="form-check-label" for="meeting">Meeting Discussions</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" id="actionPoint" type="radio" value="2" name="meeting" (change)="changeFileFilter(2);isFileUpload=false;">
                  <label class="form-check-label" for="actionPoint">Actions Points</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" id="message" type="radio" value="3" name="meeting" (change)="changeFileFilter(3);isFileUpload=false;">
                  <label class="form-check-label" for="message">Chat</label>
                </div>
              </div>
            </div>
            <div class="border rounded bg-white py-4 text-center text-muted mb-3 mt-3" *ngIf="fileList.length ===0 || fileList ==null">
              <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
              <h5 class="py-4 text-center">No Data Available</h5>
            </div>
            <div class="p-3 border rounded-bottom rounded-right bg-light my-3" *ngFor="let objFile of fileList">
              <span class="text-secondary f-bold-dubai pr-2">{{objFile.createByName}}</span> <small class="text-muted">{{objFile.createDate | date:'dd/MM/yyyy h:mm a '}}</small>
              <div class="attachement-card rounded p-2 mt-2 position-relative">
                <i class="la fa-lg " [ngClass]="checkFileType(objFile.fileName)"></i> {{objFile.fileName}}
                <div class="card-controls position-absolute position-top-5 position-right-15 text-secondary pt-1">
                  <ul class="list-inline list-badge hide-arrow-drop">

                    <li class="list-inline-item nav-item" ngbDropdown>
                      <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
                      <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <li><a ngbDropdownItem (click)="DownloadFiles(objFile)"><i class="fa fa-download"></i> Download</a></li>
                        <li><a ngbDropdownItem (click)="onDeleteFiles(objFile)"><i class="fa fa-trash"></i> Delete</a></li>
                        <li><a ngbDropdownItem (click)="openFileRename(fileRenameTemplate,objFile)"><i class="fa fa-edit"></i> Rename</a></li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>


          </div>
          <div class="col-md-6 pt-3 pt-md-2 mt-md-5" *ngIf="isFileUpload">
            <div class="center">
              <form #demoForm="ngForm" class="position-relative">
                <button type="button" *ngIf="uploadedFiles.length >0 " class="position-absolute position-bottom-55 position-right-15 position-zindex1 btn btn-success btn-sm f-bold-dubai px-2 mb-2" (click)="uploadAttachedFiles('0','Meeting')"> Upload Files({{uploadedFiles.length}}) </button>


                <file-upload [(ngModel)]="uploadedFiles" class="pointer" name="files"></file-upload>
                <small>Maximum limit is 10 files, Max file size is 20MB<br />Supported file format :<span class="text-warning rounded px-2 p-0 m-0"> .jpeg, .jpg, .png, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .mp4, .pdf</span></small>

              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer bg-white w-100 position-absolute position-bottom-0">
  <button type="button" class="btn text-secondary f-bold-dubai px-4 border-0 bg-white" (click)="closeConfirm()">Cancel</button>
  <button type="button" *ngIf="!show" class="btn btn-success f-bold-dubai px-4" (click)="onSubmitGeneral(gf)">Next</button>
  <button type="button" *ngIf="show" class="btn btn-outline-secondary f-bold-dubai px-4" (click)="onSubmitGeneral(gf)">{{saveButtonText}}</button>
  <button type="button" *ngIf="show && !model.workFlowCondition1  && model.approvalStatus == 'Draft'" class="btn btn-success f-bold-dubai px-4" (click)="openReviewModal(templateReview,'MSENDREVIEW')">Send for Review</button>
  <button type="button" class="btn btn-success f-bold-dubai px-4" (click)="openPubModal(templatePublish)" *ngIf="model.workFlowCondition1">Publish</button>
</div>

<!--modal end-->
<!--modal import start-->
<ng-template #importtemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Retrieve from Outlook</h4> <span style="color:#ccc;font-size:12px;margin-top: 12px;
    margin-left: 10px;"> ( For better data retrieval speed please use the short time duration)</span>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalImport.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body py-3">
    <div class="position-relative px-3">
      <div class="custom-tab1">
        <div class="row">
          <div class="col-md-3 col-lg-4">
            <!-- <input type="date" onkeydown="return false" id="dateView" class="form-control mb-3" [(ngModel)]="outlookDate" /> -->
            <input type="date" (keydown)="preventKeydown($event)" (change)="setCurrentTime()" [max]="maxDate" id="dateView" class="form-control mb-3" [(ngModel)]="outlookDate" />
          </div>

          <div class="col-lg-3 col-md-4">
            <div class="form-group">
              <input type="time" class="form-control" [(ngModel)]="startOutlookTime">
            </div>
          </div>
          <div class="col-lg-3 col-md-4">
            <div class="form-group">
              <input type="time" class="form-control" [(ngModel)]="endOutlookTime" [disabled]="isEndTimeDisabled" >
            </div>
            <div *ngIf="getOutlookError()"
                 class="error-txt p-1">
              Must be greater than start time
            </div>
          </div>
          <div class="col-lg-2 col-md-2">
            <div class="form-group">
              <button class="btn btn-success border" (click)="!getOutlookError() && openOutlookDialog()">Retrieve</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white border-top border p-3 text-secondary text-center mim-hgt-300">
      <div class="loader-bg" *ngIf="isLoader"></div>
      <div class="no-data" *ngIf="meetingAppoinments && meetingAppoinments.length==0  && !isLoader">
        <div class="pt-2 px-3 pb-3 border-bottom text-center">
          <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
          <h5 class="pb-4 pt-2 text-center text-secondary">No Data Available</h5>



        </div>
      </div>
      <div class="row" *ngFor="let meetObj3 of meetingAppoinments">
        <div class="list-schedule w-100">
          <div class="row">
            <div class="col-3 col-sm-2 text-right  px-4  res-fs-14">{{meetObj3.start |timeFormat}} to {{meetObj3.end |timeFormat}}</div>
            <div class="col-9 col-sm-10 col-lg-9 text-left border-left bullet-circle pb-3 pt-1 px-4">
              <span class="user-icon-select text-primary" style="cursor:pointer" (click)="selectOutlookMeeting(meetObj3)"><i class="las la-chevron-circle-right fa-2x"></i></span>
              <h6 class="text-primary f-bold-dubai res-fs-14 res-pr-25 pr-4">{{meetObj3.subject}} </h6>
              <i class="la la-calendar-o fa-lg float-left"></i> {{meetObj3.meetingDate }}<br>
              <i class="la la-map-marker fa-lg float-left"></i><span class="float-left overflow-hidden w-94 word-bread-text">{{meetObj3.location}}</span>
            </div>
          </div>



        </div>
      </div>
    </div>

  </div>

</ng-template>

<ng-template #templatePublish>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Publish MOM</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalPub.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p *ngIf="!model.workFlowCondition1">
      This Minutes of Meeting will be published and sent to all attendees. No
      changes can be made in the document once you submit.<br /><br />
      Note: Your digital signature may be added to the attached documents as well
    </p>
    <p *ngIf="model.workFlowCondition1">
      You have not set a workflow for this Minutes of Meeting.<br />
      Would you like to Publish with you as the Reviewer and Approver?<br /><br />
      Note: Your digital signature may be added to the attached documents as well.
    </p>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn text-secondary bg-white border-0" (click)="modalPub.hide()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="updateMeetingStatus('MPUBLISH')">Publish<span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1 position-relative position-top-minus-5"></span></button>
  </div>
</ng-template>



<ng-template #templateReview>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Send For Review</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalReview.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      This Minutes of Meeting will be sent to the following user(s) for Review:<br />
    </p>
  </div>
  <div class="content-list-overflow">
    <div *ngFor="let item of reviewerList; let i = index">
      <div id="{{item.attendeesUnoAtd}}" class="d-none card mb-0 bg-white p-3 border profiledetails">
        <span class="position-absolute position-right-10 close-card pointer" (click)="closeCard(item.attendeesUnoAtd)"><i class="la la-close"></i></span>
        <div class="row profile-scroll">
          <div class="col-md-3 pr-0">
            <span><img class="img-fluid rounded-circle wh-80" [src]="item.picture" alt="Profile" /></span>
          </div>
          <div class="col-md-9">
            <div class="border-bottom">
              <h5 class="mb-0">{{item.nameAtd}}</h5>
              <p class="py-0 my-0 text-secondary">
                {{item.designation}}<br>
                <small><i class="la la-id-badge"></i>   {{item.prNumberAtd}}</small>
              </p>
            </div>
            <h5 class="pt-2 mb-0">Contact information</h5>
            <div class="row text-secondary">
              <div class="col-md-4"><i class="la la-envelope"></i> Email</div>
              <div class="col-md-8"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
            </div>
            <div class="row text-secondary">
              <div class="col-md-4"><i class="la la-comments"></i> Chat</div>
              <div class="col-md-8"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
            </div>
            <div class="row text-secondary">
              <div class="col-md-4"><i class="la la-phone-square"></i>Phone</div>
              <div class="col-md-8">{{item.contactAtd==0?'-':item.contactAtd}}</div>
            </div>
          </div>
        </div>
      </div>
      <p>
        <span class="bg-light rounded-circlebg-light rounded-circle circle-40 py-2 px-1 text-brown f-bold-dubai mx-2 border pointer text-center" (click)="profileCard(item.attendeesUnoAtd)">{{getShortName(item.nameAtd)}} </span> <b>{{item.nameAtd}}</b>
      </p>
    </div>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn text-secondary f-bold-dubai border-0 bg-white" (click)="modalReview.hide()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="updateMeetingStatus('MSENDREVIEW')">Send For Review <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1 position-relative position-top-minus-5"></span></button>
  </div>
</ng-template>
<ng-template #templateReason>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Attendee - {{atdReasonModel.status}}</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="closeAttendeeReason()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <form name="ar" id="ar" #ar="ngForm" (ngSubmit)="submitAttendeeReason(ar)" novalidate>
      <div class="row py-2 custom-tab">

        <div class="col-md-12" *ngIf="atdReasonModel.status == 'On Behalf'">
          <div class="form-group">
            <ng-select [items]="UserList" class="form-control p-0"
                       bindLabel="fullAttendeeName"
                       bindValue="fullAttendeeName"
                       required #SelectedReason="ngModel"
                       [(ngModel)]="atdReasonModel.apologizedReason"
                       id="SelectedReason"
                       name="SelectedReason"
                       [ngClass]="{ 'error':isSubmitReason  && SelectedReason.invalid }"
                       [multiple]="false"
                       [searchable]="true"
                       [searchFn]="customSearchFn"
                       [virtualScroll]="true"
                       [minTermLength]="3"
                       placeholder="Search attendees by Name or PR or Email">
              <ng-template ng-option-tmp let-item="item">
                <div class="line">{{item.fullAttendeeName}}</div>
                <div class="line-email">{{item.emailAtd}}</div>
                <div class="line-designation">{{item.designation}} {{item.division}}</div>
              </ng-template>
            </ng-select>
            <div *ngIf="isSubmitReason && SelectedReason.invalid">
              <div class="text-danger"> Select the user</div>
            </div>
          </div>
        </div>

        <div class="col-md-12" *ngIf="atdReasonModel.status == 'Apologized'">
          <div class="form-group">
            <textarea class="form-control" rows="3"
                      required #SelectedReason="ngModel"
                      [(ngModel)]="atdReasonModel.apologizedReason"
                      id="SelectedReason"
                      name="SelectedReason"
                      [ngClass]="{ 'error':isSubmitReason  && SelectedReason.invalid }"
                      placeholder="Apologize Reason ">
            </textarea>
            <div *ngIf="isSubmitReason && SelectedReason.invalid">
              <div class="text-danger"> Enter the Apologize Reason</div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 w-100">
          <button type="button" class="btn pull-right btn text-secondary f-bold-dubai px-4 border-0 bg-white" (click)="closeAttendeeReason()">Cancel</button>
          <button class="btn pull-right btn-success px-4">Save</button>
        </div>
      </div>
    </form>
  </div>

</ng-template>

<ng-template #templateActionPoint>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">{{enableAP ==false?'Meeting Discussions':subPoint == ''?'Action Points':'Sub-Point'}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeActionPoint()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>

  <form name="actionForm" id="actionForm" #actionForm="ngForm" (ngSubmit)="submitEditActionPoint(actionForm)" novalidate>
  <div class="modal-body px-3" style="height: 75vh !important;overflow: scroll;">    
      <div class="row py-2 custom-tab">
        <div class="col-md-12">
          <div class="form-group position-relative">
            <label for="note" class="required">{{enableAP ==false?'Meeting Discussions':subPoint == ''?'Action Points':'Sub-Point'}} <span class="text-danger">*</span></label>

            <quill-editor theme="snow" id="note" required #note="ngModel" class="custom-form-control" style="background-color:#f1f1f1"
                          name="note" [ngClass]="{ 'error':isSubmitReason  && note.invalid }" [(ngModel)]="apModel.note" [styles]="editorStyle" placeholder="Enter your text here">
            </quill-editor>
            <div *ngIf="isSubmitReason && note.invalid">
              <div class="text-danger"> Enter the {{enableAP?'Action Point':'Meeting Discussion'}}</div>
            </div>
          </div>
        </div>

        <div class="col-md-6 pt-3" *ngIf="enableAP">
          <div class="form-group">
            <label for="dueDate">Due Date</label>
            <input type="date" onkeydown="return false" class="form-control col-md-12" id="dueDate" #dueDate="ngModel"
                   name="dueDate" [(ngModel)]="apModel.dueDate" placeholder="Set Date">
          </div>
        </div>
        <div class="col-md-6 pt-3" *ngIf="enableAP">
          <div class="form-group">
            <label for="priority">Priority</label>

            <select class="custom-select form-control col-md-12" placeholder="Set Priority" [(ngModel)]="apModel.priority" #priority="ngModel" id="priority" name="priority">
              <option value="Low Priority">Low Priority </option>
              <option value="Medium Priority">Medium Priority</option>
              <option value="High Priority">High Priority</option>
            </select>
          </div>
        </div>

        <div class="col-md-12" *ngIf="enableAP">
          <div class="form-group">
            <label for="responsibility">Responsibility</label>
            <!--<ng-select [items]="UserList" class="form-control p-0"
                       bindLabel="fullAttendeeName"
                       bindValue="userselUno"
                       [(ngModel)]="apModel.responsibility"
                       id="responsibility"
                       name="responsibility"
                       [multiple]="true"
                       [searchable]="true"
                       [virtualScroll]="true"
                       [minTermLength]="3"
                       placeholder="Assign Responsibility">
            </ng-select>-->
            <ng-select [items]="attendeeDDList" class="form-control col-md-12 p-0"
                       bindLabel="nameAtd"
                       bindValue="attendeesUnoAtd"
                       #responsibility="ngModel"
                       [(ngModel)]="apModel.responsibility"
                       id="responsibility"
                       name="responsibility"
                       [multiple]="true"
                       [searchable]="true"
                       [virtualScroll]="true"
                       [minTermLength]="3"
                       placeholder="Assign Responsibility">
            </ng-select>
          </div>
        </div>
      </div>
  </div>
  <div class="modal-footer border-0 p-0">
    <div class="float-right">
      <button class="btn pull-right btn-success">Save</button>
      <button type="button" class="btn pull-right text-secondary border-0 bg-white mr-2" (click)="closeActionPoint()">Cancel</button>

    </div>
  </div>
</form>

</ng-template>

<ng-template #templateFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">File Attachment</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalPub.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12 px-2 pb-70">
        <div class="border rounded bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="actionFileList.length ===0||actionFileList==null">
          <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
          <h5 class="py-4 text-center">No Data Available</h5>
        </div>
        ss
        <div class="p-3 border rounded-bottom rounded-right bg-light my-3 position-relative" *ngFor="let objFile of actionFileList">
          <span class="text-secondary f-bold-dubai pr-2">{{objFile.createByName}}</span> <small class="text-muted">{{objFile.createDate | date:'dd/MM/yyyy h:mm a '}}</small>
          <div class="attachement-card rounded p-2 mt-2">
            <i class="la fa-lg " [ngClass]="checkFileType(objFile.fileName)"></i> {{objFile.fileName}}
            <div class="card-controls position-absolute position-top-10 position-right-15 text-secondary pt-1">
              <ul class="list-inline list-badge hide-arrow-drop">

                <li class="list-inline-item nav-item" ngbDropdown>
                  <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
                  <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <li><a ngbDropdownItem (click)="DownloadFiles(objFile)"><i class="fa fa-download"></i> Download</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary" (click)="modalPub.hide()">Close</button>

  </div>
</ng-template>

<ng-template #fileRenameTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Rename File</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="fileRename.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form name="file" (ngSubmit)="file.form.valid && renameFile()" #file="ngForm" novalidate>
    <div class="modal-body">

      <div class="form-group">
        <label for="exampleInputEmail1">File Name<span class="text-danger">*</span></label>
        <input type="text" class="form-control" name="fileName" [(ngModel)]="model1.fileName" placeholder="File Name" #fileName1="ngModel" [ngClass]="{ 'is-invalid': file.submitted && fileName1.invalid }" required>
        <div *ngIf="file.submitted && fileName1.invalid" class="invalid-feedback">
          <div *ngIf="fileName1.errors.required">File Name is required</div>

        </div>
      </div>


    </div>
    <div class="modal-footer border-0">
      <button type="button" class="btn btn-outline-secondary" (click)="fileRename.hide()">Cancel</button>
      <button class="btn btn-success">Submit</button>
    </div>
  </form>
</ng-template>
